import { AxiosInstance } from 'axios';

export type StockListFormat = 'xlsx' | 'csv';

export const createStockListsApi = (api: AxiosInstance) => ({
  /**
   * Downloads a business partner's stock list (Bestandsliste) as a blob. The
   * endpoint is BP-scoped, so the file carries that partner's own prices and
   * the request must go through the authenticated axios instance.
   */
  downloadStockList: (businessPartnerId: number, format: StockListFormat) =>
    api.get<Blob>(`/v1/stock-lists/${businessPartnerId}`, {
      params: { format },
      responseType: 'blob',
    }),
});
